import { useEffect, useRef, useState } from "react";

import { googleNonceDigest, loadGoogleIdentity } from "../lib/googleIdentity";


const REFRESH_MS = 4 * 60 * 1000;

export default function GoogleIdentityButton({ createChallenge, onCredential }) {
  const buttonRef = useRef(null);
  const onCredentialRef = useRef(onCredential);
  const [error, setError] = useState("");
  const [attempt, setAttempt] = useState(0);
  onCredentialRef.current = onCredential;

  useEffect(() => {
    let active = true;
    let refreshTimer;
    const buttonNode = buttonRef.current;

    async function prepare() {
      try {
        if (buttonNode) buttonNode.replaceChildren();
        const challenge = await createChallenge();
        const [googleIdentity, nonce] = await Promise.all([
          loadGoogleIdentity(), googleNonceDigest(challenge.nonce),
        ]);
        if (!active || !buttonNode) return;
        googleIdentity.initialize({
          client_id: challenge.web_client_id,
          nonce,
          ux_mode: "popup",
          auto_select: false,
          callback: async ({ credential }) => {
            if (!active || !credential) return;
            try {
              setError("");
              await onCredentialRef.current(challenge.challenge_id, credential);
            } catch (caught) {
              const detail = caught?.response?.data?.detail;
              setError(typeof detail === "string" ? detail : caught?.message || "Google sign-in failed.");
            }
          },
        });
        buttonNode.replaceChildren();
        googleIdentity.renderButton(buttonNode, {
          theme: "outline", size: "large", shape: "rectangular", text: "continue_with",
        });
        setError("");
        refreshTimer = window.setTimeout(prepare, REFRESH_MS);
      } catch (caught) {
        const detail = caught?.response?.data?.detail;
        if (active) setError(typeof detail === "string" ? detail : caught?.message || "Google sign-in is unavailable.");
      }
    }

    prepare();
    return () => {
      active = false;
      window.clearTimeout(refreshTimer);
      if (buttonNode) buttonNode.replaceChildren();
    };
  }, [createChallenge, attempt]);

  return (
    <div>
      <div ref={buttonRef} aria-label="Continue with Google" data-testid="consumer-google-button" />
      {error && <div className="mt-2 text-sm text-red-200" role="alert">{error} <button type="button" className="underline" onClick={() => setAttempt((value) => value + 1)}>Retry Google sign-in</button></div>}
    </div>
  );
}
